module.exports = __webpack_public_path__ + "img/icon-copy-2.6451b786.png";